import React, { useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import './index.scss'

interface IScaleProps {
  disableScale?: boolean;
  product?: IMallDoProduct;
  // 用于锁定的选项
  disableScaleNo?: string;
  selectScaleNo?: string;
  scaleGroupName?: string;
  onChange?: (data: any) => void;
}

const SelectScales: React.FC<IScaleProps> = ({ product, disableScale, disableScaleNo, selectScaleNo, onChange }) => {
  const [scaleNo, setScaleNo] = useState(disableScaleNo || selectScaleNo || product.scaleNo)
  const [scale, setScale] = useState({ no: product.scaleNo || '', cnt: product.saleCnt || 0 })

  const showScales = useMemo(() => {
    return product.scales?.length > 1 || product.scales?.[0]?.name
  }, [product.scales])

  const handleSelectScale = (item) => {
    if (disableScale) {
      // if (item.cnt === 0 || disableScale) {
      return
    }
    if (disableScaleNo) return
    setScaleNo(item.no)
    setScale(item)
    onChange(item.no)
  }

  return (
    <div className='mall-select-scales-container'>
      {
        showScales ? (
          <div className={`choose-scale-list${disableScale ? ' disable-scale' : ''}`}>
            <div className='title space-between'>
              <span>{product.scaleGroupName} {scale && scale.no ? <span style={{ marginLeft: '10px' }}>{`${i18n.t('mall.stock')}:${scale.cnt}`}</span> : ''}</span>
            </div>
            <div className='item-list'>
              {
                product.scales.map(item => {
                  return (
                    <div
                      className={`item${item.no === scaleNo ? ' selected' : ''}${item.cnt === 0 ? ' sold-out' : ''}`}
                      key={item.no}
                      onClick={() => handleSelectScale(item)}
                    >
                      <div
                        className='info'
                      >
                        <span className='name'>{item.name}{item.cnt === 0 ? `[${i18n.t('mall.scaleNotCnt')}]` : ''}</span>
                        {/* {!!(item.pic && item.remark) && (<span className='scale-remark'>{item.remark}</span>)} */}
                        {/* <div className='price'>{format.toPrice(item.actualPrice)} {!!(item.discountPrice && item.discountPrice > 0) && <del> {format.toPrice(item.price)}</del>}</div>
                        {item.saleCnt >= 0 && (
                          <div className='sub-price-limit'>
                            {item.saleCnt > 0 ? (
                              <span>{`(${i18n.t('cart.limit')}: ${
                                item.saleCnt
                              })`}
                              </span>
                            ) : (
                              <span className='soldout-tag'>
                                {i18n.t('common.soldout')}
                              </span>
                            )}
                          </div>
                        )} */}
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </div>
        ) : null
      }
    </div>
  )
}

export default observer(SelectScales)
